
// SVG Icon: show-more
export default { id: "terriajs-show-more" };
export const id = "terriajs-show-more";
export const name = "show-more";
